import styled from 'styled-components';
import colors from 'app/src/styles/colors';

export const DateTimePicker = styled.input`
  border: 1px solid ${colors.border};
  border-radius: 4px;
  padding: 12px;
  font-family: 'Avenir', 'Avenir Next', -apple-system, sans-serif;
  font-size: 16px;
  color: ${colors.text};
  background-color: ${colors.background};

  &:focus {
    outline: none;
    border-color: ${colors.borderFocus};
    box-shadow: 0 0 0 2px ${colors.focus}20;
  }
`;
